import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Alert, Snackbar, Button, TextField, IconButton, Select, MenuItem } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { fetchCustomerSupportComplaints, deleteCustomerSupportComplaint, emailCustomerSupportComplaintPdf, fetchCustomers, fetchSolutions, fetchVehicles, updateCustomerSupportComplaint } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';

export function CustomerSupportComplaint() {
  const navigate = useNavigate();
  const location = useLocation();
  const [haulierOptions, setHaulierOptions] = React.useState([]);
  const [truckOptions, setTruckOptions] = React.useState([]);
  const [vehicleData, setVehicleData] = React.useState([]);
  const [searchVehicle, setSearchVehicle] = React.useState('');


  const [devicesOptions, setDevicesOptions] = React.useState([]);
  const [sendingEmailId, setSendingEmailId] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
  const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};


  const fetchTrucks = async () => {
    try {
      const response = await fetchCustomerSupportComplaints();
      console.log(response.data);

      setCustomerSupportComplainData(response.data);
      showSnackbar('Customer Support Complain fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching Customer Support Data';
      showSnackbar(`Failed to fetch Customer Support Data: ${errorMessage}`, 'error');
    }
  };
  const fetchHauliers = async () => {
    try {
      const response = await fetchCustomers();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setHaulierOptions(haulierDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const fetchDevices = async () => {
    try {
      const response = await fetchSolutions();
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setDevicesOptions(deviceDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchTruck = async () => {
    try {
      const response = await fetchVehicles();
      console.log(response.data);
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.registration_number;
        return acc;
      }, {});
      setTruckOptions(haulierDict)
      setVehicleData(response.data)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const handleSendEmail = async (saleId) => {
    setSendingEmailId(saleId);

    try {
      await emailCustomerSupportComplaintPdf(saleId, {});
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Email error:", error);
      alert("Failed to send email.");
    } finally {
      setSendingEmailId(null);
    }
  };

  React.useEffect(() => {
    fetchTrucks();
    fetchHauliers();
    fetchDevices();
    fetchTruck();
  }, []);

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  React.useEffect(() => {
    if (location.state?.successMessage) {
      showSnackbar(location.state.successMessage, 'success');
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const [customerSupportData, setCustomerSupportComplainData] = React.useState([])
  // Save customerSupportData to localStorage on update
  React.useEffect(() => {
    localStorage.setItem('customerSupport', JSON.stringify(customerSupportData));
    console.log(customerSupportData, 'customerSupportData');

  }, [customerSupportData]);
  const handleDelete = async (id) => {
    try {
      await deleteCustomerSupportComplaint(id);
      showSnackbar("Customer deleted successfully", "success");
    } catch (error) {
      showSnackbar("Failed to delete customer", "error");
      console.error(error);
    }
  };
  const handleExport = () => {
    const doc = new jsPDF('l', 'mm', 'a3');

    // Title
    doc.setFontSize(18);
    doc.text('Customer Support Complain Report', 14, 16);

    // Match your UI headers
    const columns = [
      'Complain #',
      'Customer',
      'Vehicle',
      'Complainant',
      'Category',
      'Details',
      'Document',
      'Status',
    ];

    // Build table data
    const tableData = customerSupportData.map((complain) => [
      complain.id,
      haulierOptions[complain.customer] || "",
      truckOptions[complain.vehicle] || "",
      complain.complainant || "",
      complain.category || "",
      complain.details || "",
      complain.document_url ? "Available" : "Not Available",
      complain.status || "",
    ]);

    // Generate table
    doc.autoTable({
      head: [columns],
      body: tableData,
      startY: 30,
      styles: {
        fontSize: 9,
        cellPadding: 2,
      },
      columnStyles: {
        0: { cellWidth: 25 },  // Complain #
        1: { cellWidth: 35 },  // Customer
        2: { cellWidth: 35 },  // Vehicle
        3: { cellWidth: 35 },  // Complainant
        4: { cellWidth: 35 },  // Category
        5: { cellWidth: 70 },  // Details
        6: { cellWidth: 35 },  // Document
        7: { cellWidth: 30 },  // Status
      },
      theme: 'grid',
      didDrawPage: function () {
        doc.setFontSize(18);
        doc.text('Customer Support Complain Report', 14, 16);
      },
    });

    doc.save('Customer_Support_Complain_Report.pdf');
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "92vw", sm: 400 },
    bgcolor: "background.",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
  borderRadius: 3,
  maxHeight: "90vh",
  overflowY: "auto",
    p: 4,
  };

  const updateCustomerSupportComplain = async (updatedCustomerSupportComplain, id) => {
    const formData = new FormData();
    for (const key in updatedCustomerSupportComplain) {
      formData.append(key, updatedCustomerSupportComplain[key]);
    }
    try {
      await updateCustomerSupportComplaint(id, formData);
      showSnackbar('Customer Support Complain updated successfully', 'success');
    } catch (error) {
      showSnackbar('Failed to update device', 'error');
    }
  };
  const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
      await updateCustomerSupportComplaint(saleId, updatedSale);

      // Update state in frontend
      setCustomerSupportComplainData((prevData) =>
        prevData.map((item) =>
          item.id === saleId ? { ...item, status: newStatus } : item
        )
      );

      showSnackbar('Status updated successfully', 'success');
    } catch (error) {
      console.error('Failed to update status:', error);
      showSnackbar('Failed to update status', 'error');
    }
  };

  const filteredCustomerSupportData = searchVehicle
    ? customerSupportData.filter((sale) =>
      truckOptions[sale.vehicle_details?.id]
        ?.toLowerCase()
        .includes(searchVehicle.toLowerCase())
    )
    : customerSupportData;

  return (
    <Container maxWidth="xl" sx={{ m: 2 }}>
      <DataTable
        title="Customer Support Complain List"
        columns={[
          { key: 'id', label: 'Complain #' },
          { key: 'customer', label: 'Customer', render: (complain) => haulierOptions[complain.customer] },
          { key: 'vehicle', label: 'Vehicle', render: (complain) => truckOptions[complain.vehicle] },
          { key: 'complainant', label: 'Complainant' },
          { key: 'category', label: 'Category' },
          { key: 'details', label: 'Details', render: (complain) => <div style={{ maxHeight: '80px', overflow: 'auto' }}>{complain.details}</div> },
          { key: 'document_url', label: 'Document', render: (complain) => complain.document_url ? (
            <a href={`https://crm-backend.monit.tech/${complain.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
          ) : <span style={{ color: '#999' }}>Not Available</span> },
          { key: 'status_tc', label: 'Technical Status' },
        ]}
        rows={filteredCustomerSupportData}
        toolbarActions={<>
          <TextField size="small" placeholder="Search Vehicle..." value={searchVehicle} onChange={(e) => setSearchVehicle(e.target.value)} />
          <Button variant="contained" color="primary" onClick={() => navigate('/customer-support-complaint/add')}>Add Customer Complain</Button>
          <Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>
        </>}
        renderActions={(complain) => <>
          <IconButton color="secondary" size="small" onClick={() => navigate(`/customer-support-complaint/edit/${complain.id}`, { state: { record: complain } })} sx={{ padding: '6px' }} disabled={complain.status === 'Closed'}><EditIcon /></IconButton>
          <IconButton color="error" size="small" onClick={() => handleDeleteClick(complain.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={complain.status === 'Complete'}><DeleteIcon /></IconButton>
          <IconButton color="primary" size="small" onClick={() => handleSendClick(complain.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === complain.id}>
            {sendingEmailId === complain.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          </IconButton>
          <Select value={complain.status} onChange={(e) => handleStatusChange(complain.id, e.target.value, complain)} size="small" sx={{ ml: 1, minWidth: 100 }}>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="In Progress">In Progress</MenuItem>
            <MenuItem value="Resolved">Resolved</MenuItem>
            <MenuItem value="Complete">Complete</MenuItem>
          </Select>
        </>}
      />
          {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}




